'use client';

import { Center, Loader, createStyles } from '@mantine/core';

const useSpinnerStyle = createStyles(() => ({
  outerContainer: {
    minHeight: 240,
  },
}));

const Spinner = () => {
  const { classes } = useSpinnerStyle();
  return (
    <Center className={classes.outerContainer}>
      <Loader />
    </Center>
  );
};

export default Spinner;
